// shared/modelMap.js

const internalModelMap = {
  // GPT family
  'gpt': 'gpt',
  'gpt-4o': 'gpt',
  'gpt-4o-mini': 'gpt',
  'gpt-4.1': 'gpt',
  'gpt-4.1-mini': 'gpt',
  'gpt-5': 'gpt',
  'gpt-5-mini': 'gpt',
  'gpt-5-nano': 'gpt',
  'o1': 'gpt',
  'o1-pro': 'gpt',
  'o3': 'gpt',
  'o3-pro': 'gpt',
  'GPT-4o Mini': 'gpt',
  'GPT-4o': 'gpt',
  'GPT-5': 'gpt',
  'GPT-5 Mini': 'gpt',

  // Claude family
  'claude': 'claude',
  'claude-opus-4-20250514': 'claude',
  'claude-opus-4-20250805': 'claude',
  'claude-opus-4-1-20250805': 'claude',
  'claude-4-opus': 'claude',
  'claude-4-opus-20250514': 'claude',
  'claude-sonnet-4-20250514': 'claude',
  'claude-3.7-sonnet': 'claude',
  'claude-3-haiku-20240307': 'claude',
  'Claude Opus 4': 'claude',
  'Claude Opus 4.1': 'claude',
  'Claude Sonnet 4': 'claude',

  // Gemini family
  'gemini': 'gemini',
  'gemini-1.5-flash': 'gemini',
  'gemini-1.5-pro': 'gemini',
  'gemini-2.5-flash': 'gemini',
  'gemini-2.5-flash-lite': 'gemini',
  'gemini-2.5-pro': 'gemini',
  'Gemini 1.5 Flash': 'gemini',
  'Gemini 2.5 Flash': 'gemini',
  'Gemini 2.5 Flash Lite': 'gemini',
  'Gemini 2.5 Pro': 'gemini',
};

function resolveInternalKey(name) {
  if (!name) return null;
  
  // Try direct lookup first
  let key = internalModelMap[name];
  if (key) {
    console.log('[resolveInternalKey]', { input: name, resolved: key });
    return key;
  }
  
  // Try lowercase lookup
  key = internalModelMap[name.toLowerCase()];
  if (key) {
    console.log('[resolveInternalKey]', { input: name, resolved: key });
    return key;
  }
  
  // Try to extract base model name and lookup
  const normalized = name.toLowerCase();
  if (normalized.includes('gpt')) {
    console.log('[resolveInternalKey]', { input: name, resolved: 'gpt' });
    return 'gpt';
  }
  if (normalized.includes('claude')) {
    console.log('[resolveInternalKey]', { input: name, resolved: 'claude' });
    return 'claude';
  }
  if (normalized.includes('gemini')) {
    console.log('[resolveInternalKey]', { input: name, resolved: 'gemini' });
    return 'gemini';
  }
  
  console.log('[resolveInternalKey]', { input: name, resolved: null });
  return null;
}

function resolveFriendlyName(key) {
  const friendly = {
    gpt: 'GPT',
    claude: 'Claude',
    gemini: 'Gemini'
  };
  return friendly[key] || key;
}

module.exports = { resolveInternalKey, resolveFriendlyName };